import { useEffect, useState, type ReactNode } from 'react';
import { apiRequest } from '../../api/client.js';
import { useAuth } from '../../auth/AuthProvider.js';
import { useTranslation } from '../../../../shared/i18n/index.js';

interface ErrorRow {
  readonly errorId: string;
  readonly sourceType: string;
  readonly errorType: string;
  readonly status: string;
  readonly retryCount: number;
}

export function M20ErrorMonitoringPage(): ReactNode {
  const { t } = useTranslation();
  const { token } = useAuth();
  const [rows, setRows] = useState<ErrorRow[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    apiRequest<{ data: ErrorRow[] }>('/v1/integration/errors', { token })
      .then((r) => { if (alive) setRows(r.data); })
      .catch((e) => { if (alive) setError((e as Error).message); });
    return () => { alive = false; };
  }, [token]);

  if (error) return <p role="alert">{error}</p>;
  if (!rows) return <p>{t('m20.errorMonitoring.loading')}</p>;
  return (
    <main aria-label="error-monitoring">
      <h1>{t('m20.errorMonitoring.title')}</h1>
      <table aria-label="integration-errors-table">
        <thead><tr><th>{t('m20.errorMonitoring.colSource')}</th><th>{t('m20.errorMonitoring.colType')}</th><th>{t('m20.errorMonitoring.colStatus')}</th><th>{t('m20.errorMonitoring.colRetries')}</th></tr></thead>
        <tbody>
          {rows.map((e) => (
            <tr key={e.errorId}>
              <td>{e.sourceType}</td>
              <td>{e.errorType}</td>
              <td>{e.status}</td>
              <td>{e.retryCount}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </main>
  );
}
